import ApexCharts from 'apexcharts'

window.ApexCharts = ApexCharts;

window.Apex = {
  colors:['#2979ff', '#00c853', '#ff9100', '#ff1744', '#3d5afe']
};
